import {createContext} from 'react'

export const VideoContext = createContext({
  isPlaying: false,
  play: () => {},
  pause: () => {},
  hideVideo: () => {},
  toggleMute: () => {},
  toggleExpand: () => {}
})